import { transparentize } from 'polished'
import styled from 'styled-components'

import { helpers } from '../../../styles/theme'

export const Container = styled.a`
	padding: 8px 12px;
	border: 1px solid ${helpers.color.border};
	border-radius: 8px;
	width: fit-content;
	height: fit-content;
	display: flex;
	align-items: center;
	column-gap: 8px;
	color: ${helpers.color.text};
	text-decoration: none;
	transition: color 100ms ease-in-out, background-color 100ms ease-in-out;

	min-height: 38px;

	&:focus,
	&:active {
		color: ${helpers.color.text};
		text-decoration: none;
	}

	&:hover {
		text-decoration: none;
		color: ${helpers.color.link};
		background-color: ${helpers.color.link.with(transparentize(0.92))};
	}
`
